import { TargetData } from "./TargetData";
import { getSelectedYear } from "../../../context/YearContext";

export class TargetsLink {
  constructor() {
    this.timeSlots = []; // 전체 시간대 데이터
  }

  async request(datetime, distance, year = getSelectedYear()) {
    try {
      const response = await fetch(process.env.REACT_APP_API_BASE_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify({
          "bk-working": "rounds",
          "datetime": datetime,
          "distance": distance,
          "year": year,
        }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      this.receiveJSON(data);
      return this;
    } catch (error) {
      console.error("TargetsLink request failed:", error);
      throw error;
    }
  }

  receiveJSON(resultData) {
    this.timeSlots = [];

    const timeSlotsData = resultData?.time_slots || [];

    // 각 시간대별로 데이터 파싱
    timeSlotsData.forEach((timeSlotData) => {
      const roundSchedule = timeSlotData.round_schedule || null;
      const roundsData = timeSlotData.rounds || [];

      const rounds = roundsData.map((roundJson) =>
        TargetData.fromJson(roundJson)
      );

      this.timeSlots.push({
        round_schedule: roundSchedule,
        rounds: rounds,
      });
    });

    return true;
  }
}
